import React, { memo } from 'react';
import { DialogTitle, Box, Typography, IconButton, SvgIconProps } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import DesktopRecommendedNotice from './DesktopRecommendedNotice';

interface ModalHeaderProps {
  icon?: React.ComponentType<SvgIconProps>;
  title: string;
  onClose: () => void;
  titleExtra?: React.ReactNode;
  actions?: React.ReactNode;
  subtitle?: React.ReactNode;
  disableClose?: boolean;
  /** An admin editor built for desktop: shows the "best on desktop" notice under the header below `md` (900px). */
  desktopRecommended?: boolean;
  /** Additional sx for DialogTitle */
  sx?: Record<string, unknown>;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  icon: Icon,
  title,
  onClose,
  titleExtra,
  actions,
  subtitle,
  disableClose,
  desktopRecommended,
  sx,
}) => (
  <>
    <DialogTitle sx={sx}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {Icon && <Icon color="primary" />}
          <Typography variant="h6">{title}</Typography>
          {titleExtra}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {actions}
          <IconButton aria-label={`Close ${title}`} onClick={onClose} size="small" disabled={disableClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      {subtitle}
    </DialogTitle>
    {/* A sibling of the title, so screen readers do not read the notice as part of the dialog's heading. */}
    {desktopRecommended && <DesktopRecommendedNotice sx={{ mx: 3, mb: 1 }} />}
  </>
);

export default memo(ModalHeader);
